module.exports = __webpack_public_path__ + "img/5.4c5d13f1.png";